export default {
    'OK': 200,
    'UNAUTHORIZED': 401,
    'FORBIDDEN': 403,
    'NOT_FOUND': 404,
    'BAD_REQUEST': 400,
    'INTERNAL_SERVER_ERROR': 500,
}
